import { useState } from "react";
import { IDataResult, ResponseStatus } from "../../common/models/Result";
import { useForm } from "../../common/viewmodels/DefaultVM";
import { DataUtils } from "../../common/views/DataUtils";
import { RouteUtils } from "../../common/views/RouteUtils";
import { ChangePasswordModel } from "../models/AccountTypes";
import { AccountService } from "../services/AccountService";

export function useChangePasswordVM() {
    const accountService = new AccountService();

    const [loading, setLoading] = useState(false);

    const {
        form, setField, resetForm, errorMessages, summaryText, summaryType
    } = useForm<ChangePasswordModel>({
        currentPassword: "",
        newPassword: ""
    });

    const submit = () => {
        setLoading(true);
        const request = accountService.changePassword(form);
        DataUtils.onRequest(request, onReresult);
    }

    const onReresult = (result: IDataResult) => {
        if (result.status === ResponseStatus.success) {
            resetForm();
            RouteUtils.goHome();
        }

        setLoading(false);
    }

    return {
        form,
        setField,
        errorMessages,
        summaryText,
        summaryType,

        loading,
        submit
    };
}